module.exports = {
      id: "shareicon-usage",
      viewBox: "0 0 74 74",
      url: __webpack_public_path__ + "svg-sprite-fa9bd75c1e834befd19aa957a85e34e1.svg#shareicon",
      toString: function () {
        return this.url;
      }
    }